export default {
  "content": "<path d=\"M17 6.06a.6.6 0 00-.26-.49L11.8 2.12a.7.7 0 00-.69-.06.61.61 0 00-.36.55v2.64H7c-2.76 0-5 2.18-5 4.88C2 12.81 4.24 15 7 15h7.4c.46 0 .83-.36.83-.81a.82.82 0 00-.83-.81H7a3.3 3.3 0 01-3.33-3.26A3.3 3.3 0 017 6.88h3.75V9.5c0 .23.14.45.36.55.23.1.5.08.7-.06l4.93-3.45a.6.6 0 00.26-.49z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "fill": "#707070",
    "viewBox": "0 0 18 18"
  }
};